import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Clickable from '../Clickable'
import { isVitalSourceURL } from '../LCSplitPane'
import { rewriteEbookUrl } from '../../../shared/lib/ebookUrl'

import closeImg from 'Assets/x-icon-gray.svg'

import baseStyle from 'Styles/base.css'
import style from './style.css'

export default function EbookSplitMobile (props) {
  let ebookData = {}
  if (props.PSPItem && typeof props.PSPItem === 'object') {
    ebookData.title = props.PSPItem.displayValue

    if (isVitalSourceURL(props.PSPItem.pageId)) {
      ebookData.url = props.PSPItem.pageId
    } else {
      ebookData.isLegacyEbook = true
    }
  } else if (props.ActivityScoreData && typeof props.ActivityScoreData === 'object') {
    ebookData = isVitalSourceURL(props.ActivityScoreData.curCard.meta.ebook, true)
  }

  let url = ebookData.url
  url = rewriteEbookUrl(url)

  const bumpDownClass = props.isPreview ? style.bumpDownClass : ''

  return (
    <div className={classnames(style.container, bumpDownClass)}>
      <div className={style.pageTitle}>
        <span
          dangerouslySetInnerHTML={{ __html: 'e-Book Section' }}
        />
        <Clickable
          data-test-id="closeSplitScreenEbook"
          className={style.headerClickableRight}
          onClick={props.onClick}
        >
          <input
            type="image"
            alt="close splitscreen ebook"
            src={closeImg}
            className={classnames(baseStyle.svgIcon, style.closeEbook)}
          />
        </Clickable>
      </div>
      <div className={style.innerContent}>
        <iframe
          src={url}
          className={classnames(style.contentiFrame)}
          title={ebookData.title}
          name={ebookData.title}
        />
      </div>
    </div>
  )
}

EbookSplitMobile.propTypes = {
  onClick: PropTypes.func.isRequired,
  isPreview: PropTypes.bool,
  PSPItem: PropTypes.object,
  ActivityScoreData: PropTypes.object
}
